import { ROUTES } from 'src/enums';
import auth from 'src/router/auth';
import profile from 'src/router/profile';
import blog from 'src/router/blog';
import social from 'src/router/social';
import reply from 'src/router/reply';
import books from 'src/router/books';
import my from 'src/router/my';

// For single Spa/Main layout page use useMainLayout method,
// if you need nested routes use auth/profile like example
function useMainLayout({ name, path, component }) {
  return {
    path,
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/MainLayout.vue'),
        children: [
          {
            path: '',
            name,
            meta: { auth: true },
            component,
          },
        ],
      },
    ],
  };
}

const routes = [
  ...auth,
  ...profile,
  ...blog,
  ...social,
  ...reply,
  ...books,
  ...my,
  useMainLayout({
    path: '/domains',
    name: ROUTES.DOMAINS.INDEX,
    component: () => import('pages/DomainsPage.vue'),
  }),
  useMainLayout({
    path: '/payment-providers',
    name: ROUTES.PAYMENT_PROVIDERS,
    component: () => import('pages/PaymentProviders.vue'),
  }),
  useMainLayout({
    path: '/webinars',
    name: ROUTES.WEBINARS,
    component: () => import('pages/WebinarsPage.vue'),
  }),
  useMainLayout({
    path: '/brand-voice',
    name: ROUTES.BRAND_VOICE,
    component: () => import('pages/BrandVoicePage.vue'),
  }),
  useMainLayout({
    path: '/leads',
    name: ROUTES.LEADS,
    component: () => import('pages/LeadsPage.vue'),
  }),
  {
    path: '/home',
    component: () => import('layouts/SpaLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: '',
        name: ROUTES.HOME,
        meta: { auth: true },
        component: () => import('pages/HomePage.vue'),
      },
    ],
  },
  {
    path: '/teams',
    component: () => import('layouts/SpaLayout.vue'),
    meta: { auth: true },
    children: [
      {
        path: '',
        name: ROUTES.TEAMS,
        meta: { auth: true },
        component: () => import('pages/TeamsPage.vue'),
      },
      {
        path: ':inviteGuid',
        name: ROUTES.TEAMS_INVITE,
        meta: { auth: true },
        component: () => import('pages/TeamsPage.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/RenderLayout.vue'),
    children: [
      {
        path: '',
        name: ROUTES.RENDER.BLOG,
        component: () => import('pages/RenderBlogPage.vue'),
      },
      {
        path: ':postSlug.html',
        name: ROUTES.RENDER.POST,
        component: () => import('pages/RenderPostPage.vue'),
      },
      {
        path: 'not_found',
        name: ROUTES.RENDER.NOT_FOUND,
        component: () => import('pages/RenderPostNotFoundPage.vue'),
      },
    ],
  },
  {
    path: '/404',
    name: ROUTES.NOT_FOUND,
    component: () => import('pages/NotFoundPage.vue'),
  },
  {
    path: '/500',
    name: ROUTES.INTERNAL_SERVER_ERROR,
    component: () => import('pages/InternalServerError.vue'),
  },
  {
    path: '/:catchAll(.*)',
    component: () => import('pages/NotFoundPage.vue'),
  },
];

export default routes;
